export enum NativeAchorEnum {
  HOMEPAGE = 'myvfitbiz://view/native/home?overlayType=none'
}

export const NATIVE_ANCHOR: typeof NativeAchorEnum = NativeAchorEnum;
